const logger = (msg, data, show = true) => {
  if (show) console.log(msg, data);
};

export default logger;
